import {
  Box,
  Button,
  Divider,
  Group,
  Modal,
  Stack,
  Text,
  Textarea,
  Title,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { X } from 'tabler-icons-react';

interface Props {
  isDisabledModalOpen: boolean;
  handleClose: () => void;
  disableName: string;
  disableTitle?: String;
  disableFunction: (reason: string) => Promise<void>;
}

const DisabledModal = ({
  isDisabledModalOpen,
  handleClose,
  disableName,
  disableTitle,
  disableFunction,
}: Props) => {
  const form = useForm({
    initialValues: {
      reason: '',
    },
    validate: {},
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async ({ reason }: { reason: string }) => {
    setIsLoading(true);
    await disableFunction(reason);
    setIsLoading(false);
  };

  return (
    <Modal
      size='xl'
      className='disable-modal'
      opened={isDisabledModalOpen}
      onClose={() => {
        form.setFieldValue('reason', '');

        handleClose();
      }}
      centered
      closeOnClickOutside={isLoading ? false : true}
      closeOnEscape={isLoading ? false : true}
      data-cy='declineModal'
      withCloseButton={false}
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack p='xl'>
          <Group>
            <Box
              sx={() => ({
                borderRadius: 8,
                backgroundColor: '#4F4F4F',
                color: '#fff',
                height: '3.81rem',
                width: '3.81rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              })}
            >
              <X />
            </Box>
            <Stack spacing='xs'>
              <Title>Disable{disableTitle ? ' ' + disableTitle : ''}</Title>
              <Text>Are you sure you want to disable {disableName}?</Text>
            </Stack>
          </Group>

          <Divider mt={4} mb={4} />

          <Textarea
            label='Enter Reason'
            value={form.values.reason}
            onChange={(e) => form.setFieldValue('reason', e.target.value)}
            minRows={4}
            maxRows={12}
            required
            autosize
            data-cy='reasonTextArea'
          />
          <Group mt={8} grow>
            <Button
              variant='default'
              onClick={() => {
                form.setFieldValue('reason', '');

                handleClose();
              }}
              disabled={isLoading}
              data-cy='closeButton'
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: '#ff3232' }}
              type='submit'
              loading={isLoading}
              data-cy='submitButton'
              onClick={() => {
                handleClose();
              }}
            >
              Disable
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default DisabledModal;
